import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw'
mapboxgl.accessToken = 'pk.eyJ1IjoiZWxlYW5vcmhvIiwiYSI6ImNqcDlobGUyZzA3YjAzcHFqYXI1M283NGEifQ.3gcb9MfGgLii0nrl85IqSQ';

const colorDict = { // 0 - 10
    0: "rgb(222, 208,223)", //0
    1: "rgb(223, 211, 215)",
    2: "rgb(241, 235, 239)",
    3: "rgb(249, 246, 241)",
    4: "rgb(243, 255, 245)",
    5: "rgb(180, 231, 214)",
    6: "rgb(153, 221, 182)",
    7: "rgb(133, 218, 197)",
    8: "rgb(79, 190, 184)",
    9: "rgb(0, 170, 183)",
    10: "rgb(1, 157, 182)", //10
}

/**
 * @property {mapboxgl.Map} map
 */
class Map extends Component {



    render() {
        return (
            <div id="MapBoxMap">
            </div>
        )
    }

    mountMap = () => {
        var {
            lng,
            lat,
            zoom,
        } = this.props;
        this.map = new mapboxgl.Map({
            container: 'MapBoxMap',
            containerStyle: {
                height: "100%",
                width: "100%"
            },
            style: 'mapbox://styles/mapbox/streets-v8',
            center: [lng, lat],
            zoom: zoom,
            clickTolerance: 20,
        });

        this.map.on('load', this.initMapBox);
        this.map.on('move', this.mapMove);
        this.map.on("mouseenter", "shanghai", this.mapMouseEnter)
        this.map.on('click', "shanghai", this.mapClick)
        this.map.on("mousemove", "shanghai", this.mapMouseHover);
        this.map.on("mouseleave", "shanghai", this.mapMouseLeave);
        this.map.on('touchend', this.touchEnd);
        this.map.on('touchstart', this.touchStart);

        this.map.on('draw.create', this.updatePolygon);
        this.map.on('draw.delete', this.updatePolygon);
        this.map.on('draw.update', this.updatePolygon);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.loaded && this.props.loaded) {
            this.mountMap();
        }
        else {
            if (this.props.geoJson !== prevProps.geoJson) {
                this.changeSource();
                this.updateColor();
            }
            if (JSON.stringify(this.props.weights) != JSON.stringify(prevProps.weights)) {
                this.updateColor();
            }
            if (this.props.mode != prevProps.mode) {
                if (this.map.getSource('source')) {
                    this.map.setFeatureState({ source: 'source', id: this.clickedStateId }, { click: false });
                    this.clickedStateId = null;
                    this.props.onChangeCell(null);

                    let visibility = this.props.mode == "grid" ? "visible" : "none";
                    this.map.setLayoutProperty('shanghai', 'visibility', visibility);
                    this.map.setLayoutProperty('grid', 'visibility', visibility);
                }
                var control = document.getElementsByClassName('mapboxgl-ctrl-group')[0];
                if (control) {
                    control.style.visibility = this.props.mode == "grid" ? "hidden" : "visible";
                }
                this.draw.deleteAll();
                var iconPolygon = document.getElementsByClassName('mapbox-gl-draw_polygon')[0];
                iconPolygon.style.pointerEvents = 'all';
                iconPolygon.style.opacity = 1;
            }
        }
    }


    initMapBox = () => {
        this.draw = new MapboxDraw({
            displayControlsDefault: false,
            controls: {
                polygon: true,
                trash: true
            }
        });
        this.map.addControl(this.draw);

        this.map.addSource('source', {
            "type": "geojson",
            "data": this.props.geoJson,
        });

        this.map.addLayer({
            "id": "shanghai",
            "type": "fill",
            "source": "source",
            "layout": {},
            "paint": {
                "fill-color": ["feature-state", "color"],
                "fill-opacity": ["case",
                    ["boolean",
                        ["feature-state", "click"],
                        false
                    ],
                    0.5,
                    0.5 //fallback
                ],
            }
        });

        this.map.addLayer({
            "id": "grid",
            "type": "line",
            "source": "source",
            "layout": {},
            "paint": {
                "line-color": "#1890ff", //"#4264fb",//grid line blue
                "line-width": ["case",
                    ["boolean",
                        ["feature-state", "click"],
                        false
                    ],
                    2,
                    0 //fallback
                ],
            }
        });
        // console.log('just added source and layers')
        this.updateColor();

        let visibility = this.props.mode == "grid" ? "visible" : "none";
        this.map.setLayoutProperty('shanghai', 'visibility', visibility);
        this.map.setLayoutProperty('grid', 'visibility', visibility);

        this.popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false
        });

        var control = document.getElementsByClassName('mapboxgl-ctrl-group')[0];
        if (control) {
            control.style.visibility = this.props.mode == "grid" ? "hidden" : "visible";
        }
    }

    /** Is called when the size of the grid change (with the slider),
    and so changes the source of the map's grid with the new geoJson data,
    updates the values of FAR and building diversity **/
    changeSource = () => {
        if (this.map.getSource('source')) {
            this.map.getSource('source').setData(this.props.geoJson);
            this.map.setFeatureState({ source: 'source', id: this.clickedStateId }, { click: false });
            this.clickedStateId = null;
            this.props.onChangeCell(null);
            // console.log('changeSource finish')
        };
    }

    updatePolygon = (e) => {
        var data = this.draw.getAll();
        var iconPolygon = document.getElementsByClassName('mapbox-gl-draw_polygon')[0];
        if (data.features.length > 0) {
            iconPolygon.style.pointerEvents = 'none';
            iconPolygon.style.opacity = 0.5;
            var coords = data.features[data.features.length - 1].geometry.coordinates[0]; // lasso area coords
            this.props.onChangePolygon(coords);
        } else {
            iconPolygon.style.pointerEvents = 'all';
            iconPolygon.style.opacity = 1;
            this.props.onChangePolygon(null);
        }
    }


    updateColor = () => {
        if (this.map.getSource('source')) {
            if (this.props.geoJson && this.props.geoJson.features) {
                this.props.geoJson.features.forEach((x) => {
                    this.map.setFeatureState(
                        {
                            source: 'source', id: x.id
                        }, {
                            color: this.scoreToColor(this.props.getScore(x.properties))
                        });
                })
            }
        }
    }

    scoreToColor = (score) => { // use far as score for now
        let temp = score; // 0 - 10
        if (temp > 10) { temp = 10; }
        temp = Number(Math.floor(temp));
        return (colorDict[temp])
    }

    mapMove = () => {
        const { lng, lat } = this.map.getCenter();
        const zoom = this.map.getZoom();
        this.props.onChangeMap(lng.toFixed(4), lat.toFixed(4), zoom.toFixed(2));
    }

    mapMouseEnter = (e) => {
        this.map.getCanvas().style.cursor = 'pointer';
    }

    mapClick = (e) => {
        if (e.features.length > 0) {
            // if one feature (district) was previously clicked, when click on new feature, set previous feature' state 'click' back to false
            if (this.clickedStateId) {
                this.map.setFeatureState({ source: 'source', id: this.clickedStateId }, { click: false });
                this.clickedStateId = null;
                this.props.onChangeCell(null);
            }
            // when click, set the state 'click' of the clicked feature (district) to true
            this.clickedStateId = e.features[0].id;
            this.map.setFeatureState({ source: 'source', id: this.clickedStateId }, { click: true });
            this.props.onChangeCell(e.features[0]);
        }
    }

    mapMouseHover = (e) => {
        if (e.features.length > 0) {
            if (this.hoveredStateId) {
                this.map.setFeatureState({ source: 'source', id: this.hoveredStateId }, { hover: false });
            }
            this.hoveredStateId = e.features[0].id;
            this.map.setFeatureState({ source: 'source', id: this.hoveredStateId }, { hover: true });
        }

        var center = e.lngLat;
        var description = `<strong> Score: ${this.props.getScore(e.features[0].properties).toFixed(4)} </strong>`;

        this.popup.setLngLat(center)
            .setHTML(description)
            .addTo(this.map);
    }


    mapMouseLeave = (e) => {
        this.map.getCanvas().style.cursor = '';
        if (this.hoveredStateId) {
            this.map.setFeatureState({ source: 'source', id: this.hoveredStateId }, { hover: false });
        }
        this.hoveredStateId = null;
        this.popup.remove();
    }

    touchEnd = (e) => {
        console.log(e);
        if (this.lastPosition) {
            let delta = Math.sqrt(Math.pow((e.point.x - this.lastPosition.x), 2) + Math.pow((e.point.y - this.lastPosition.y), 2))
            console.log(delta);
            if (delta > 10) return;
        }
        let features = this.map.queryRenderedFeatures(e.point, { layers: ['shanghai'] });
        this.mapClick({ features });

    }

    touchStart = (e) => {
        console.log(e);
        this.lastPosition = e.point;
    }


}

export default Map
